import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.array.sort";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "E:\\RiderProjects\\pdcweb\\node_modules\\@babel\\runtime-corejs2/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.function.name";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import { SortField, toTree, getchild } from "../../utils/helper";
import { quillEditor } from 'vue-quill-editor';
import { RefreshToken } from "../../api/Auth";
var that;
var roleArr = [];
export default {
  name: 'user',
  data: function data() {
    var _this = this;

    var checkPass = function checkPass(rule, value, callback) {
      if (value !== _this.user.Password) {
        callback(new Error('两次输入密码不一致！'));
      } else {
        callback();
      }
    };

    return {
      balances: [],
      UpdateRoleAndDept: false,
      deptArr: [],
      deptTree: [],
      headTitle: '',
      viewVisible: false,
      isadd: false,
      user: {},
      editVisible: false,
      users: [],
      pageCount: 1,
      multipleSelection: [],
      delList: [],
      loading: false,
      roles: [],
      isResouceShow: 0,
      query: {
        Field1: '',
        Field2: '',
        Field3: '',
        Field5: '',
        PageIndex: 1,
        PageSize: 15
      },
      editorOption: {
        placeholder: '请输入内容！！！'
      },
      leftHeight: '',
      leftTreeHeight: '',
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      rules: {
        LoginId: [{
          required: true,
          message: '请输入账号',
          trigger: 'blur'
        }, {
          min: 2,
          max: 15,
          message: '长度在 3 到 15 个字符',
          trigger: 'blur'
        }],
        RealName: [{
          required: true,
          message: '请输入姓名',
          trigger: 'blur'
        }],
        Password: [{
          required: true,
          message: '请设置密码',
          trigger: 'blur'
        }, {
          min: 5,
          message: '密码长度至少5位',
          trigger: 'blur'
        }],
        agapwd: [{
          required: true,
          message: '请输入确认密码',
          trigger: 'blur'
        }, {
          min: 5,
          message: '密码长度至少5位',
          trigger: 'blur'
        }, {
          validator: checkPass,
          message: '两次密码不一致',
          trigger: 'blur'
        }],
        UserType: [{
          required: true,
          message: '请选择角色类型',
          trigger: 'blur'
        }],
        Phone: [{
          required: true,
          message: '请输入电话',
          trigger: 'blur'
        }]
      }
    };
  },
  filters: {
    usertypeFormat: function usertypeFormat(UserType) {
      var usertypeName = '';
      var item = roleArr.filter(function (t) {
        return t.id == UserType;
      });
      usertypeName = item.length > 0 ? item[0]['name'] : '';
      return usertypeName;
    }
  },
  components: {
    quillEditor: quillEditor
  },
  created: function created() {
    this.getDept();
    this.getRoles();
  },
  beforeCreate: function beforeCreate() {
    that = this;
  },
  mounted: function mounted() {
    this.setCJHeight();
  },
  methods: {
    gotolink: function gotolink(param1, param2) {
      //指定跳转地址
      this.$router.push({
        path: "/MoreDeviceInfo",
        query: {
          id: param1,
          source: param2
        }
      });
    },
    onEditorChange: function onEditorChange(_ref) {
      var editor = _ref.editor,
          html = _ref.html,
          text = _ref.text;
      this.content = html;
    },
    setCJHeight: function setCJHeight() {
      var _this2 = this;

      this.$nextTick(function () {
        // 页面渲染完成后的回调
        var headerHeight = document.getElementsByClassName('content')[0].offsetHeight;
        _this2.leftHeight = headerHeight * 0.93 + 'px';
        _this2.leftTreeHeight = headerHeight * 0.85 + 'px';
      });
    },
    handleNodeClick: function handleNodeClick(data, node, self) {
      var newdata = getchild(this.deptArr, [data.id], data.id);
      this.query.Field5 = newdata.join(',');
      this.getData();
    },
    saveEdit: function saveEdit() {
      var _this3 = this;

      this.$refs['user'].validate(function (valid) {
        if (valid) {
          var parentidPath = _this3.user.DeptIdTree;
          _this3.user.DeptId = parentidPath[parentidPath.length - 1] + '';
          _this3.isResouceShow = _this3.isResouceShow + 1;

          if (_this3.isadd) {
            _this3.$zybhttp.post('Account/UserAdd', _this3.user).then(function (res) {
              if (res.data.status == 0) {
                _this3.$notify.success('添加成功');

                _this3.getData();

                _this3.editVisible = false;
                _this3.user = {};
              } else {
                _this3.$notify.error('添加失败');
              }
            }).catch(function (err) {
              return _this3.$notify.error('网络异常！添加失败');
            });
          } else {
            _this3.$zybhttp.post('Account/UserUpdate', _this3.user).then(function (res) {
              if (res.data.status == 0) {
                _this3.$notify.success('修改成功');

                _this3.getData();

                _this3.editVisible = false;
              } else {
                _this3.$notify.error('修改失败');
              }
            }).catch(function (err) {
              return _this3.$notify.error('网络异常！修改失败');
            });
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    updateToken: function () {
      var _updateToken = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var resRefresh;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return RefreshToken();

              case 2:
                resRefresh = _context.sent;

                if (resRefresh.status === 0) {
                  localStorage.setItem('token', resRefresh.msg);
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function updateToken() {
        return _updateToken.apply(this, arguments);
      }

      return updateToken;
    }(),
    getData: function getData() {
      var _this4 = this;

      var userInfo = JSON.parse(localStorage.getItem('ms_userInfo'));
      this.query.Field1 = userInfo.userType;
      this.query.Field2 = userInfo.id + '';
      this.query.Field3 = userInfo.realName;
      this.$zybhttp.post('Balance/GetList', this.query, {// Field1: userInfo.userType,
        // Field2: userInfo.id + '',
        // Field5: userInfo.realName,
      }).then(function (res) {
        if (res.data.status == 0) {
          res = res.data;
          var d = res.data.list;
          var newdata = d.sort(SortField('Id', 'desc'));
          newdata = newdata.map(function (x) {
            x.isUseFt = x.isUse == '1';
            x.isUseMonitor = x.isShowMonitor == '1';
            return x;
          }, []);
          _this4.balances = newdata;
          _this4.pageCount = res.data.total || 0;
        } else {
          _this4.$notify.error(res.message);
        }
      }).catch(function (err) {
        return _this4.$notify.error('网络异常！获取列表失败！');
      });
    },
    getRoles: function getRoles() {
      var _this5 = this;

      // this.loading=true;
      var userInfo = JSON.parse(localStorage.getItem('ms_userInfo'));
      this.$zybhttp.post('role/GetList', {
        Field5: userInfo.id + ''
      }).then(function (res) {
        if (res.data.status == 0) {
          res = res.data;
          var d = res.data.list;
          var newdata = d.sort(SortField('Id', 'desc'));
          newdata = newdata.map(function (x) {
            x.id = x.id + '';
            return x;
          }, []);
          _this5.roles = newdata;
          roleArr = newdata;
          var userDept = parseInt(userInfo.deptId);
          var newdata = getchild(_this5.deptArr, [userDept], userDept);
          _this5.query.Field5 = newdata.join(',');

          _this5.getData();
        } else {
          _this5.$notify.error(res.message);
        }
      }).catch(function (err) {
        return _this5.$notify.error('网络异常！获取列表失败！');
      });
    },
    getAxiso: function getAxiso() {
      this.$zybhttp.get('Account/UserDel?ids=1').then(function (res) {}).catch(function (err) {
        return console.log(err, '网络异常！获取列表失败！');
      });
    },
    getDept: function getDept() {
      var _this6 = this;

      var serach = {};
      this.$zybhttp.post('Dept/GetList', {
        Field5: '1'
      }).then(function (res) {
        if (res.data.status == 0) {
          _this6.deptArr = res.data.data.list;
          var d = res.data.data.list;
          var userDept = parseInt(JSON.parse(window.localStorage.getItem('ms_userInfo')).deptId);
          var newdata = getchild(d, [userDept], userDept);
          d = d.filter(function (x) {
            return newdata.indexOf(x.id) > -1;
          });
          d = d.sort(SortField('sort', 'asc'));
          var arr = [];

          for (var i = 0; i < d.length; i++) {
            arr.push({
              id: d[i].id,
              pid: d[i].parentId,
              value: d[i].id,
              label: d[i].name
            });
          }

          _this6.deptTree = toTree(arr);
        } else {
          _this6.$notify.error(res.message);
        }
      }).catch(function (err) {
        return _this6.$notify.error('网络异常！获取列表失败！');
      });
    },
    handleEdit: function handleEdit(id, row, source) {
      this.gotolink(row.id, source);
    },
    dbSelected: function dbSelected(row) {
      this.user = row;
      var userInfo = JSON.parse(localStorage.getItem('ms_userInfo'));

      if (userInfo.userType == row.UserType) {
        this.viewVisible = true;
        return;
      }

      this.user.id = row.id;
      this.editVisible = true;
      this.isadd = false;
      var arr = new Array();

      if (this.user.DeptId != '0') {
        var d = this.user.parentIdPath.split(',');
        var char = userInfo.deptId;

        if (d.indexOf(char) > -1) {
          var a = d.slice(d.indexOf(char), d.length);

          for (var i = 0; i < a.length; i++) {
            arr.push(parseInt(a[i]));
          }
        }
      }

      arr.push(parseInt(this.user.DeptId));
      this.user.DeptIdTree = arr;
      this.headTitle = '修改用户信息';
      this.UpdateRoleAndDept = userInfo.loginId == row.LoginId;
    },
    handleShow: function handleShow(index, row) {
      this.user = row;
      this.viewVisible = true;
    },
    handleAdd: function handleAdd() {
      var ms_userInfo = localStorage.getItem('ms_userInfo');
      var userinfo = JSON.parse(ms_userInfo);
      this.user = {};
      this.isadd = true;
      var date = new Date(); // this.user.CreateDate = dateFormat.formatDate(date, 'yyyy-MM-dd hh:mm:ss');

      this.user.CreateUserId = userinfo.loginId;
      this.user.ModifyUserId = userinfo.loginId;
      this.editVisible = true;
      this.headTitle = '新增用户信息';
    },
    handlePageChange: function handlePageChange(val) {
      this.$set(this.query, 'PageIndex', val);
      this.getData();
    },
    indexMethod: function indexMethod(index) {
      return index + 1;
    }
  }
};